// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddWishListApiParameter } from "@insite/client-framework/Services/WishListService";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { WishListTotalModel } from "@plumberssupply/App/Handlers/WishLists/LoadWishLists";

export interface XngAddWishListApiParameter extends AddWishListApiParameter {
    name?: string;
    description?: string;
    // XNG-Changes
    plumbers_jobName?: string;
    plumbers_isSaved?: boolean;
    plumbers_isSingleUse?: boolean;
}

export interface XngLoadWishListsTotalApiParameter {
    wishListIds: string[];
}

const wishListUrl = "/api/v1/wishlists";
const xngWishListUrl = "/api/pls/wishlist/realtimepricing";

export function xngAddWishList(parameter: XngAddWishListApiParameter) {
    return post<WishListModel>(wishListUrl, {
        name: parameter.name,
        description: parameter.description,
        // XNG-Changes
        properties: {
            plumbers_jobName: parameter.plumbers_jobName,
            plumbers_isSaved: `${parameter.plumbers_isSaved ?? ""}`,
            plumbers_isSingleUse: `${parameter.plumbers_isSingleUse ?? ""}`,
        } as any,
    } as WishListModel);
}

export function xngLoadWishListsTotal(parameter: XngLoadWishListsTotalApiParameter): Promise<WishListTotalModel[]> {
    return post(xngWishListUrl, parameter.wishListIds);
}
